import { Box } from '@material-ui/core';
import styled from 'styled-components';

export const Wrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
`;

export const ClickableContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
`;

export const Spacer = styled(Box)`
  height: 15px;
`;

export const UrlContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const TextfieldContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  align-items: center;
`;
